import passwordValidator from 'password-validator';
var passwordSchema = new passwordValidator();
passwordSchema.is().min(8).has().uppercase().has().lowercase().has().digits().has().symbols();
export default passwordSchema;